import $ from 'jquery';
import Swiper, { Autoplay, EffectFade, Pagination } from 'swiper';
Swiper.use([ Autoplay, EffectFade, Pagination ]);

export default class HeroImageSlider {
    constructor() {
        if($('.js-hero-image-slider').length) {
            const $slider = $('.js-hero-image-slider');
            const autoplayEnabled = $slider.parent().hasClass('has-autoplay');

            const heroImageSlider = new Swiper($slider[0], {
                autoplay: autoplayEnabled ? {
                    delay: 5000
                } : false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                loop: true,
                pagination: {
                    clickable: true,
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                slidesPerView: 1,
                speed: autoplayEnabled ? 300 : false
            });

            heroImageSlider.init();
        };
    };
};
